import React from "react";
import { Result } from "antd";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/Common";

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <Result
        status="403"
        title="Nuk keni autorizim"
        subTitle="Nuk keni të drejta për të aksesuar këtë faqe ose sesioni juaj ka skaduar."
        extra={
          <Button
            variant="primary"
            onClick={() => navigate("/login", { replace: true })}
          >
            Kthehu te hyrja
          </Button>
        }
      />
    </div>
  );
};

export default UnauthorizedPage;
